'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoBluetooth = function IoBluetooth(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm10.9 11.3c1.3-1.3 1.4-1.1 1.5-1l5.3 5.1c0.2 0.1 0.8 0.8 0.8 0.2v-12.3c0-0.5 0.5-0.8 1-0.8 0.3 0 0.5 0.2 0.7 0.3s9.1 8.8 9.5 9.2 0.4 0.7 0.1 1l-6.6 6.4s-0.3 0.3-0.3 0.6 0.3 0.6 0.3 0.6l6.6 6.4c0.3 0.3 0.3 0.7-0.1 1s-9.5 9.2-9.5 9.2c-0.2 0.1-0.4 0.3-0.7 0.3-0.5 0-1-0.3-1-0.8v-12.3s-0.6 0.1-0.8 0.2v0.1l-5.3 5c-0.1 0.1-0.2 0.3-1.5-0.9s-0.9-1.4-0.8-1.5 7-6.7 7-6.7 0.3-0.2 0.3-0.6c0-0.4-0.3-0.6-0.3-0.6s-6.9-6.7-7-6.7-0.4-0.2 0.8-1.4z m11-1.9v6.1c0 0.7 0.6 0.1 0.8 0l2.3-2.4s0.2-0.4 0.2-0.5 0-0.4-0.2-0.6l-2.3-2.3c-0.2-0.2-0.8-0.9-0.8-0.3z m0 15.1v6.1s0.6-0.1 0.8-0.3l2.3-2.3c0.2-0.2 0.2-0.4 0.2-0.6s0-0.4-0.2-0.5l-2.3-2.4c-0.2-0.1-0.8-0.7-0.8 0z' })
        )
    );
};

exports.default = IoBluetooth;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/bluetooth.js
// module id = 1966
// module chunks = 0